import { MetadataRow } from "../utils/fileMetadataUtils";

interface FileMetadataSectionProps {
  metadataRows: MetadataRow[];
}

/**
 * File metadata display section
 */
export const FileMetadataSection = ({ metadataRows }: FileMetadataSectionProps) => (
  <section className="space-y-3">
    <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">File details</p>
    <dl className="grid grid-cols-1 gap-3 text-sm">
      {metadataRows.map(({ label, value }) => (
        <div key={label} className="rounded-xl border border-border bg-background px-4 py-3">
          <dt className="text-xs uppercase tracking-wide text-muted-foreground">{label}</dt>
          <dd className="mt-1 font-medium text-foreground">{value}</dd>
        </div>
      ))}
    </dl>
  </section>
);
